import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Chip } from "@mui/material";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import MainApi from "../../../../../services/mainApi.service";
import { ITicketAutomationRules } from "../../../../../models/ticket-automation-rules";
import { useCallback, useMemo, useState } from "react";
import MarComTicketAutomationRules from "./MarComTicketAutomationRulesForm/MarComTicketAutomationRules";

const TICKET_AUTOMATION_RULES_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComTicketAutomationRules/";
const ticketAutomationRulesService = new MainApi<ITicketAutomationRules>(
  TICKET_AUTOMATION_RULES_ROUTE
);

const translationPath = "page.4uMarCom.automationRules.ticketautomationRules.";

const MarComTicketAutomationRulesPage = () => {
  const { t } = useTranslation();
  const [selectedId, setSelectedId] = useState<string>();

  const { id } = useParams();
  const [automationRuleForm, setAutomationRuleForm] = useState(false);

  const columns: GridColDef<ITicketAutomationRules>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "ticketAutomation",
      headerName: t(translationPath + "automation") || "Automation",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "createdByUserName",
      headerName: t(translationPath + "created_by") || "Created By",
      maxWidth: 350,
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 120,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleAdd = () => {
    setAutomationRuleForm(true);
  };
  const handleRowClick = (params: GridRowParams<ITicketAutomationRules>) => {
    if (!params.row) return;
    setAutomationRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setAutomationRuleForm(false);
  }, []);
  const props = useMemo(() => {
    return {
      MarComAutomationRuleId: id,
    };
  }, [id]);
  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {automationRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <MarComTicketAutomationRules
            id={selectedId}
            marComAutomationRuleId={id}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!automationRuleForm && (
        <Box sx={{ height: 600 }}>
          <Table<ITicketAutomationRules>
            showDefaultMacroFilters={false}
            service={ticketAutomationRulesService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            serviceProps={props}
            searchInputPlaceHolder={
              t(translationPath + "search") || "Searh for Whatsapp template"
            }
            addButtonLabel={
              t(translationPath + "add_automation_rule") ||
              "Add Automation Rule"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default MarComTicketAutomationRulesPage;
